// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2joOw","label":"Radio_label__2Br9F","checkMark":"Radio_checkMark__2B2c0","disabled":"Radio_disabled__82CSv"};